/**
 * Smoothly scroll to a target element with a custom slow duration.
 * Provides a slower, more cinematic scroll than the browser default.
 */
export function scrollToElement(
  id: string,
  duration: number = 1300,
  offset: number = 100,
) {
  const target = document.getElementById(id)
  if (!target) return

  const startY = window.scrollY
  const targetY = target.getBoundingClientRect().top + startY - offset
  const distance = targetY - startY
  const startTime = performance.now()

  // Linear easing — constant speed throughout
  function step(now: number) {
    const elapsed = now - startTime
    const progress = Math.min(elapsed / duration, 1)
    window.scrollTo(0, startY + distance * progress)
    if (progress < 1) {
      requestAnimationFrame(step)
    }
  }

  requestAnimationFrame(step)
}
